<script>
  import { onMount } from "svelte";
  import { Router, Route, link } from "svelte-routing";

  // Layouts
  import Admin from "./layouts/Admin.svelte";
  import Auth from "./layouts/Auth.svelte";

  // Views
  import Index from "./views/Index.svelte";
  import Landing from "./views/Landing.svelte";
  import Profile from "./views/Profile.svelte";
  import Toast from './components/Control/Toast.svelte';
  import { checkAuthentication } from '../config';

  let isAuthenticated = false;
  let currentPath = "";
  // const getPath = () => {
  //   currentPath = window.location.pathname;
  //   console.log("Current Path:", currentPath);
  // };

  // onMount(async () => {
  //   getPath;
  //     isAuthenticated = await checkAuthentication();

  // });
  export let url = "";
</script>


  <Toast />
  <Router url = "{url}" >
    <Route path="/" component={Index} /> <!-- Korumasız rota -->
    <Route path="landing" component={Landing} /> <!-- Korumasız rota -->
    <Route path="profile" component={Profile} /> <!-- Korumasız rota -->
    <Route path="auth/*auth" component={Auth} /> <!-- Kimlik doğrulama rotaları -->
    <Route path="admin/*admin" component={Admin} /> <!-- Koruma altındaki rota -->
  </Router>

